import { Mail, MapPin, Phone, Clock, Globe, Facebook, Instagram, Youtube, Twitter, MessageCircle } from "lucide-react";

const waLink = (v) => {
  if (/^https?:/.test(v)) return v;
  const d = v.replace(/\D/g, "");
  return `https://wa.me/${d.length === 10 ? `91${d}` : d}`;
};

export const contactItems = (s) => [
  [MapPin, "Address", s?.address, null],
  [Phone, "Phone", s?.phone, s?.phone && `tel:${s.phone.replace(/[^\d+]/g, "")}`],
  [Mail, "Email", s?.email, s?.email && `mailto:${s.email}`],
  [Globe, "Website", s?.website_url, s?.website_url],
  [Clock, "Office hours", s?.office_hours, null],
].filter(([, , v]) => v && v.trim());

export const socialLinks = (s) => [
  [s?.social_facebook, Facebook, "facebook"],
  [s?.social_instagram, Instagram, "instagram"],
  [s?.social_youtube, Youtube, "youtube"],
  [s?.social_twitter, Twitter, "twitter"],
  [s?.social_whatsapp && waLink(s.social_whatsapp), MessageCircle, "whatsapp"],
].filter(([u]) => u);
